import { AddMerchantGQL } from '@/graphql/mutations'

export default {
  methods: {
    async addMerchant (formData, draft = true) {
      await this.$apollo.mutate({
        mutation: AddMerchantGQL,
        variables: {
          params: formData,
          draft
        }
      })
    }
  }
}
